import React from "react";
import ReactDOM from "react-dom";
import { AppContainer } from "react-hot-loader";
import "@simpleryo/collinson-uikit/src/theme.less";
import "../scss/main.scss";
import App from "./App";

const render = Component => {
  ReactDOM.render(
    <AppContainer warnings={false}>
      <Component />
    </AppContainer>,
    document.getElementById("root")
  );
};

render(App);

if (module.hot) {
  module.hot.accept("./App", () => {
    render(App);
  });
}
